export enum Warning {
  PRINTER,
  SHELL,
  MONEY,
  NETWORK,
}
